<style scoped lang="scss">
.container {
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background:
            radial-gradient(circle at 20% 20%, rgba(79, 70, 229, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(124, 58, 237, 0.05) 0%, transparent 50%);
        z-index: 0;
    }
}

.content-div {
    background: rgba(255, 255, 255, 0.95);
    width: 400px;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    position: relative;
    margin: 2rem 0;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.8);
    z-index: 1;

    .title {
        font-size: 1.5rem;
        font-weight: 600;
        color: #2d3748;
        margin-bottom: 1.5rem;
        text-align: center;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            bottom: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 40px;
            height: 3px;
            background: linear-gradient(90deg, #4f46e5, #7c3aed);
            border-radius: 3px;
        }
    }
}

:deep(.el-form) {
    .el-form-item {
        margin-bottom: 1.5rem;

        .el-form-item__label {
            font-weight: 500;
            color: #4a5568;
        }
    }
}

:deep(.el-input) {
    .el-input__wrapper {
        padding: 0.5rem 1rem;
        border-radius: 6px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        transition: all 0.2s ease;

        &:hover {
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
    }
}

:deep(.el-select) {
    width: 100%;

    .el-input__wrapper {
        padding: 0.5rem 1rem;
        border-radius: 6px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        transition: all 0.2s ease;

        &:hover {
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
    }
}

.includes-decription {
    width: 100%;
    margin-top: 1.5rem;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    background: #f8fafc;

    :deep(.el-card__header) {
        background: #f8fafc;
        padding: 1rem;
        border-bottom: 1px solid #e2e8f0;

        .card-header {
            font-weight: 600;
            color: #2d3748;
            font-size: 1rem;
        }
    }

    :deep(.el-card__body) {
        padding: 1rem;
        color: #4a5568;
        font-size: 0.95rem;
        line-height: 1.5;

        strong {
            color: #4f46e5;
            font-weight: 600;
        }
    }
}

.submit-btn {}

@media screen and (max-width: 768px) {
    .container {
        padding: 1rem;
    }

    .content-div {
        width: 90%;
        padding: 1.5rem;
        margin: 1rem 0;

        .title {
            font-size: 1.25rem;

            &::after {
                width: 30px;
                height: 2px;
            }
        }
    }

    :deep(.el-form) {
        .el-form-item {
            margin-bottom: 1rem;
        }
    }

    .includes-decription {
        margin-top: 1rem;

        :deep(.el-card__header) {
            padding: 0.75rem;
        }

        :deep(.el-card__body) {
            padding: 0.75rem;
            font-size: 0.9rem;
        }
    }

    .submit-btn {
        margin-top: 1rem;
        padding: 0.5rem;
        font-size: 0.9rem;
    }
}
</style>
<template>
    <div class="container" :style="bgStyle">
        <IndexHeader />
        <div class="content-div">
            <div class="title">免费授权</div>
            <div class="form-container">
                <el-form :label-position="form_position" label-width="80px" :model="form">
                    <el-form-item label="插件">
                        <el-select v-model="form.includes_id" placeholder="请选择" @change="selectIncludes">
                            <el-option v-for="item in includes_data" :key="item.id" :label="item.id + '---' + item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- Add version selection dropdown -->
                    <el-form-item label="功能版本" v-if="form.includes_id">
                        <el-select v-model="form.version" placeholder="请选择功能版本" @change="selectVersion"
                            :disabled="version_list.length === 0">
                            <el-option v-for="item in version_list" :key="item.version" :label="item.versionName"
                                :value="item.version"></el-option>
                            <el-option v-if="version_list.length === 0 && form.includes_id"
                                disabled>--该插件无版本信息--</el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="授权字段">
                        <el-input v-model="form.host" name="host"></el-input>
                    </el-form-item>
                    <el-form-item label="绑定邮箱">
                        <el-input v-model="form.email" name="host"></el-input>
                    </el-form-item>
                    <el-form-item label="推荐人uid">
                        <el-input v-model="form.uid" name="host"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <el-card class="box-card includes-decription">
                <template #header>
                    <div class="card-header">
                        <span>授权说明</span>
                    </div>
                </template>
                <div v-if="select_Includes.isWhole == 1">该插件<strong>支持泛域名</strong>，请填写一级域名，例如baidu.com
                    <span v-if="selected_version.free_day">, 免费时长<strong>{{ selected_version.free_day
                            }}</strong>天</span>
                    <span v-else-if="select_Includes.freeDay">, 免费时长<strong>{{ select_Includes.freeDay
                            }}</strong>天</span>
                </div>
                <div v-else-if="select_Includes.isWhole == 0">该插件不支持泛域名，请填写后台域名,例如www.baidu.com
                    <span v-if="selected_version.free_day">, 免费时长<strong>{{ selected_version.free_day
                            }}</strong>天</span>
                </div>
                <div v-else>请选择插件</div>
            </el-card>
            <div style="width:100%;">
                <div style="margin: 0.4rem auto;width: fit-content;">
                    <el-button type="success" class="submit-btn" @click="addAuth()">免费授权</el-button>
                </div>

            </div>
        </div>
        <IndexFooter />
    </div>

</template>
<script>
import { defineComponent } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import IndexHeader from '@/components/IndexHeader.vue'
import IndexFooter from '@/components/IndexFooter.vue'
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        IndexHeader,
        IndexFooter
    },
    data() {
        return {
            form: {
                host: "",
                includes_id: "",
                eamil: "",
                uid: "",
                version: "" // Add version field
            },
            includes_data: [],
            select_Includes: {},
            selected_version: {}, // Add selected version data
            version_list: [], // Add version list
            form_position: "top",
            bgImageUrl: [
                require('@/assets/img/bg2.webp'),
                require('@/assets/img/bg3.jpg'),
                require('@/assets/img/bg4.png'),
                require('@/assets/img/bg5.png'),
                require('@/assets/img/bg6.webp'),
                require('@/assets/img/bg7.webp'),
                require('@/assets/img/bg8.webp'),
                require('@/assets/img/bg9.webp'),
            ]
        }
    },
    computed: {
        bgStyle() {
            let i = Math.floor(Math.random() * this.bgImageUrl.length);
            return {
                // 'background': `url(${this.bgImageUrl[i]})`
            };
        }
    },
    methods: {
        addAuth() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token"),
                'content-type': 'application/json'
            }
            axios.post(baseURL + '/free/addAuth', JSON.stringify(this.form), { timeout: 5000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        ElMessage.success(res.data.msg)
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                }).catch(err => {
                    this.$message.error(err);
                }).finally(() => {
                    fullscreenLoading.close()
                })

        },
        selectIncludes(id) {
            for (let i = 0; i < this.includes_data.length; i++) {
                const element = this.includes_data[i];
                if (element.id == id) {
                    this.select_Includes = element;
                    break; // Add break for efficiency
                }
            }

            // Reset version selection when plugin changes
            this.form.version = "";
            this.version_list = [];
            this.selected_version = {};

            // Fetch versions for the selected plugin
            if (id) {
                this.getPluginVersions(id);
            }
        },
        getPluginVersions(soft_id) {
            openLoading();
            const headers = {
                'content-type': 'application/json'
            };

            const data = {
                soft_id: soft_id
            };

            axios.post(baseURL + "/userApi/getSoftVersion", data, { timeout: 5000, headers })
                .then(res => {
                    fullscreenLoading.close();
                    if (res.data.code == 200) {
                        this.version_list = res.data.data.list || [];
                        // Auto-select if only one version
                        if (this.version_list.length === 1) {
                            this.form.version = this.version_list[0].version;
                            this.selectVersion(this.version_list[0].version);
                        }
                    } else {
                        ElMessage.error(res.data.msg || '获取版本信息失败');
                    }
                })
                .catch(err => {
                    fullscreenLoading.close();
                    console.log(err);
                    ElMessage.error('获取版本信息失败：' + err.message);
                });
        },
        selectVersion(version) {
            // Find the selected version in the list
            this.selected_version = this.version_list.find(item => item.version === version) || {};
        },
        getIncludes() {
            axios.get(baseURL + '/free/getFreeIncludes', { timeout: 5000 }).then(
                res => {
                    if (res.data.code == 200) {
                        this.includes_data = res.data.data
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                }, err => {
                    ElMessage.error(err)
                }
            )
        },
        setFormPosition() {
            window.innerWidth < 768 ? this.form_position = "top" : this.form_position = "left"
        }
    },
    mounted() {
        this.getIncludes()
        this.setFormPosition()
    }
})
</script>